

const user_SelectedEditor = "user_SelectedEditor";

export function getSelectedEditor(){
    return getValue(user_SelectedEditor)||"JODIT";
}
export function SetSelectedEditor(Editor){
    setValue(user_SelectedEditor,Editor);
    return getValue(user_SelectedEditor);
}

const rpp_support = "rpp_support";

export function getRppSupport(){
    return getValue(rpp_support)||25;
}
export function SetRppSupport(number){
    setValue(rpp_support,number);
    return getValue(rpp_support);
}

const rpp_dashSupport = "rpp_dashSupport";

export function getRppDashSupport(){
    return getValue(rpp_dashSupport)||5;
}
export function SetRppDashSupport(number){
    setValue(rpp_dashSupport,number);
    return getValue(rpp_dashSupport);
}

const rpp_dashNote = "rpp_dashNote";

export function getRppDashNote(){
    return getValue(rpp_dashNote)||5;
}
export function SetRppDashNote(number){
    setValue(rpp_dashNote,number);
    return getValue(rpp_dashNote);
}

const rpp_phoneBook = "rpp_phoneBook";

export function getRppPhoneBook(){
    return getValue(rpp_phoneBook)||10;
}
export function SetRppPhoneBook(number){
    setValue(rpp_phoneBook,number);
    return getValue(rpp_phoneBook);
}

const rpp_transactionAllManagement = "rpp_transactionAllManagement";
export function getRppTransactionAllManagement(){
    return getValue(rpp_transactionAllManagement)||15;
}
export function SetRppTransactionAllManagement(number){
    setValue(rpp_transactionAllManagement,number);
    return getValue(rpp_transactionAllManagement);
}

const rpp_articlesManagement = "rpp_articlesManagement";
export function getRppArticlesManagement(){
    return getValue(rpp_articlesManagement)||5;
}
export function SetRppArticlesManagement(number){
    setValue(rpp_articlesManagement,number);
    return getValue(rpp_articlesManagement);
}

const rpp_affiliateManagement = "rpp_affiliateManagement";
export function getRppAffiliateManagement(){
    return getValue(rpp_affiliateManagement)||5;
}
export function SetRppAffiliateManagement(number){
    setValue(rpp_affiliateManagement,number);
    return getValue(rpp_affiliateManagement);
}

const rpp_corporateManagement = "rpp_corporateManagement";
export function getRppCorporateManagement(){
    return getValue(rpp_corporateManagement)||5;
}
export function SetRppCorporateManagement(number){
    setValue(rpp_corporateManagement,number);
    return getValue(rpp_corporateManagement);
}
const rpp_corporateIncreaseDeposit = "rpp_corporateIncreaseDeposit";
export function getRppCorporateIncreaseDeposit(){
    return getValue(rpp_corporateIncreaseDeposit)||15;
}
export function SetRppCorporateIncreaseDeposit(number){
    setValue(rpp_corporateIncreaseDeposit,number);
    return getValue(rpp_corporateIncreaseDeposit);
}

const rpp_corporateTransactions = "rpp_corporateTransactions";
export function getRppCorporateTransactions(){
    return getValue(rpp_corporateTransactions)||15;
}
export function SetRppCorporateTransactions(number){
    setValue(rpp_corporateTransactions,number);
    return getValue(rpp_corporateTransactions);
}
const rpp_corporatePersonnel = "rpp_corporatePersonnel";
export function getRppCorporatePersonnel(){
    return getValue(rpp_corporatePersonnel)||10;
}
export function SetRppCorporatePersonnel(number){
    setValue(rpp_corporatePersonnel,number);
    return getValue(rpp_corporatePersonnel);
}
const rpp_transactionCorporateManagement = "rpp_transactionCorporateManagement";
export function getRppTransactionCorporateManagement(){
    return getValue(rpp_transactionCorporateManagement)||15;
}
export function SetRppTransactionCorporateManagement(number){
    setValue(rpp_transactionCorporateManagement,number);
    return getValue(rpp_transactionCorporateManagement);
}
const rpp_transactionIncomeManagement = "rpp_transactionIncomeManagement";
export function getRppTransactionIncomeManagement(){
    return getValue(rpp_transactionIncomeManagement)||15;
}
export function SetRppTransactionIncomeManagement(number){
    setValue(rpp_transactionIncomeManagement,number);
    return getValue(rpp_transactionIncomeManagement);
}
const rpp_transactionPlaceManagement = "rpp_transactionPlaceManagement";
export function getRppTransactionPlaceManagement(){
    return getValue(rpp_transactionPlaceManagement)||15;
}
export function SetRppTransactionPlaceManagement(number){
    setValue(rpp_transactionPlaceManagement,number);
    return getValue(rpp_transactionPlaceManagement);
}
const rpp_transactionUserManagement = "rpp_transactionUserManagement";
export function getRppTransactionUserManagement(){
    return getValue(rpp_transactionUserManagement)||15;
}
export function SetRppTransactionUserManagement(number){
    setValue(rpp_transactionUserManagement,number);
    return getValue(rpp_transactionUserManagement);
}
const rpp_invoiceManagement = "rpp_invoiceManagement";
export function getRppInvoiceManagement(){
    return getValue(rpp_invoiceManagement)||10;
}
export function SetRppInvoiceManagement(number){
    setValue(rpp_invoiceManagement,number);
    return getValue(rpp_invoiceManagement);
}
const rpp_invoiceDetailBuyables = "rpp_invoiceDetailBuyables";
export function getRppInvoiceDetailBuyables(){
    return getValue(rpp_invoiceDetailBuyables)||20;
}
export function SetRppInvoiceDetailBuyables(number){
    setValue(rpp_invoiceDetailBuyables,number);
    return getValue(rpp_invoiceDetailBuyables);
}
const rpp_locationManagement = "rpp_locationManagement";
export function getRppLocationManagement(){
    return getValue(rpp_locationManagement)||5;
}
export function SetRppLocationManagement(number){
    setValue(rpp_locationManagement,number);
    return getValue(rpp_locationManagement);
}
const rpp_linkManagement = "rpp_linkManagement";
export function getRppLinkManagement(){
    return getValue(rpp_linkManagement)||5;
}
export function SetRppLinkManagement(number){
    setValue(rpp_linkManagement,number);
    return getValue(rpp_linkManagement);
}
const rpp_mainPageList = "rpp_mainPageList";
export function getRppMainPageList(){
    return getValue(rpp_mainPageList)||5;
}
export function SetRppMainPageList(number){
    setValue(rpp_mainPageList,number);
    return getValue(rpp_mainPageList);
}
const rpp_placeManagement = "rpp_placeManagement";
export function getRppPlaceManagement(){
    return getValue(rpp_placeManagement)||5;
}
export function SetRppPlaceManagement(number){
    setValue(rpp_placeManagement,number);
    return getValue(rpp_placeManagement);
}
const rpp_cateringManagement = "rpp_cateringManagement";
export function getRppCateringManagement(){
    return getValue(rpp_cateringManagement)||5;
}
export function SetRppCateringManagement(number){
    setValue(rpp_cateringManagement,number);
    return getValue(rpp_cateringManagement);
}

const rpp_foodManagement = "rpp_foodManagement";
export function getRppFoodsManagement(){
    return getValue(rpp_foodManagement)||5;
}
export function SetRppFoodsManagement(number){
    setValue(rpp_foodManagement,number);
    return getValue(rpp_foodManagement);
}

const rpp_placeSells = "rpp_placeSells";
export function getRppPlaceSells(){
    return getValue(rpp_placeSells)||25;
}
export function SetRppPlaceSells(number){
    setValue(rpp_placeSells,number);
    return getValue(rpp_placeSells);
}
const rpp_placeOptionManagement = "rpp_placeOptionManagement";
export function getRppPlaceOptionManagement(){
    return getValue(rpp_placeOptionManagement)||50;
}
export function SetRppPlaceOptionManagement(number){
    setValue(rpp_placeOptionManagement,number);
    return getValue(rpp_placeOptionManagement);
}
const rpp_purchasedCourseManagement = "rpp_purchasedCourseManagement";
export function getRppPurchasedCourseManagement(){
    return getValue(rpp_purchasedCourseManagement)||5;
}
export function SetRppPurchasedCourseManagement(number){
    setValue(rpp_purchasedCourseManagement,number);
    return getValue(rpp_purchasedCourseManagement);
}
const rpp_purchasedAllManagement = "rpp_purchasedAllManagement";
export function getRppPurchasedAllManagement(){
    return getValue(rpp_purchasedAllManagement)||25;
}
export function SetRppPurchasedAllManagement(number){
    setValue(rpp_purchasedAllManagement,number);
    return getValue(rpp_purchasedAllManagement);
}
const rpp_purchasedSubscribeManagement = "rpp_purchasedSubscribeManagement";
    export function getRppPurchasedSubscribeManagement(){
    return getValue(rpp_purchasedSubscribeManagement)||25;
}
export function SetRppPurchasedSubscribeManagement(number){
    setValue(rpp_purchasedSubscribeManagement,number);
    return getValue(rpp_purchasedSubscribeManagement);
}
const rpp_sportsManagement = "rpp_sportManagement";
export function getRppSportsManagement(){
    return getValue(rpp_sportsManagement)||25;
}
export function SetRppSportsManagement(number){
    setValue(rpp_sportsManagement,number);
    return getValue(rpp_sportsManagement);
}
const rpp_userManagement = "rpp_userManagement";
export function getRppUserManagement(){
    return getValue(rpp_userManagement)||25;
}
export function SetRppUserManagement(number){
    setValue(rpp_userManagement,number);
    return getValue(rpp_userManagement);
}
const rpp_corporateInvoice = "rpp_corporateInvoice";
export function getRppCorporateInvoice(){
    return getValue(rpp_corporateInvoice)||25;
}
export function SetRppCorporateInvoice(number){
    setValue(rpp_corporateInvoice,number);
    return getValue(rpp_corporateInvoice);
}
const rpp_userInvoice = "rpp_userInvoice";
export function getRppUserInvoice(){
    return getValue(rpp_userInvoice)||25;
}
export function SetRppUserInvoice(number){
    setValue(rpp_userInvoice,number);
    return getValue(rpp_userInvoice);
}
const rpp_userIncreaseDeposit = "rpp_userIncreaseDeposit";
export function getRppUserIncreaseDeposit(){
    return getValue(rpp_userIncreaseDeposit)||25;
}
export function SetRppUserIncreaseDeposit(number){
    setValue(rpp_userIncreaseDeposit,number);
    return getValue(rpp_userIncreaseDeposit);
}
const rpp_personalTransaction = "rpp_personalTransaction";

export function getRppPersonalTransaction(){
    return getValue(rpp_personalTransaction)||25;
}
export function SetRppPersonalTransaction(number){
    setValue(rpp_personalTransaction,number);
    return getValue(rpp_personalTransaction);
}
const rpp_personnelTransactions = "rpp_personnelTransactions";

export function getRppPersonnelTransactions(){
    return getValue(rpp_personnelTransactions)||25;
}
export function SetRppPersonnelTransactions(number){
    setValue(rpp_personnelTransactions,number);
    return getValue(rpp_personnelTransactions);
}
const rpp_settlementsRequest = "rpp_settlementsRequest";

export function getRppSettlementsRequest(){
    return getValue(rpp_settlementsRequest)||25;
}
export function SetRppSettlementsRequest(number){
    setValue(rpp_settlementsRequest,number);
    return getValue(rpp_settlementsRequest);
}
const rpp_SettingActivities = "rpp_SettingActivities";

export function getRppSettingActivities(){
    return getValue(rpp_SettingActivities)||25;
}
export function SetRppSettingActivities(number){
    setValue(rpp_SettingActivities,number);
    return getValue(rpp_SettingActivities);
}

const rpp_UserActivity = "rpp_UserActivity";

export function getRppUserActivity(){
    return getValue(rpp_UserActivity)||25;
}
export function SetRppUserActivity(number){
    setValue(rpp_UserActivity,number);
    return getValue(rpp_UserActivity);
}
const rpp_userPurchasedSubscribe = "rpp_userPurchasedSubscribe";

export function getRppUserPurchasedSubscribe(){
    return getValue(rpp_userPurchasedSubscribe)||25;
}
export function SetRppUserPurchasedSubscribe(number){
    setValue(rpp_userPurchasedSubscribe,number);
    return getValue(rpp_userPurchasedSubscribe);
}

const rpp_smsList = "rpp_smsList";

export function getRppSmsList(){
    return getValue(rpp_smsList)||25;
}
export function SetRppSmsList(number){
    setValue(rpp_smsList,number);
    return getValue(rpp_smsList);
}


function getValue(key) {
    return  localStorage.getItem(key);
}
function setValue(key,value) {
    localStorage.setItem(key, value);
}
